"use client";

import {
  type FilterDefinition,
  type QuickFilterContext,
  type QuickFilterDefinition,
  useRouterParams,
} from "@zapier/shared";
import { AppsVersionFilterController } from "./controllers/AppsVersionFilterController";

export interface AppsFilterConfig {
  filters: FilterDefinition[];
  quickFilters: QuickFilterDefinition[];
  quickFilterContext: QuickFilterContext;
  onFilterInteraction: (type: string) => void;
  search: string | undefined;
}

// Version analytics emit inside AppsVersionFilterController; the only
// dimension on the Apps view, so we don't need a top-level handler.
const noop = () => {};

// Apps view's filter-bar config. One always-set filter: the data-source
// toggle between latest-public-versions and other-versions. Writes the same
// `shared` URL param the legacy SharingFilter used (preserves deep links).
export function useAppsFilterConfig(): AppsFilterConfig {
  const { search } = useRouterParams();

  const filters: FilterDefinition[] = [
    {
      type: "version",
      icon: "navApps",
      labelKey: "version.label",
      paramNames: ["shared"],
      Controller: AppsVersionFilterController,
    },
  ];

  const quickFilters: QuickFilterDefinition[] = [];
  const quickFilterContext: QuickFilterContext = {};

  return {
    filters,
    quickFilters,
    quickFilterContext,
    onFilterInteraction: noop,
    search: search ?? undefined,
  };
}
